
export const Constants  = {
    API_DELETE_FAILURE: 'APIDeleteFailure',
    API_DELETE_MESSAGE: 'APIDeleteMessage',
    UNSUBSCRIBE_CONFIRMATION: 'ConfirmSubscriptionRemoval',
    API_MOVE_PUBLIC_CONDITION: 'APIMovePublicCondition'
};



// WEBPACK FOOTER //
// C:/Users/sthanga1/Documents/apicloud-x/apicloud-x/apim-ui-newgen/src/app/core/constants/constants.ts